import React, {useEffect, useState} from "react";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import TableSection from "./TableSection";
import {ItemListadoServiciosHotel, listarServiciosHotel} from "../../../services/hotelServicios";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/servicios",
        label: "Servicios"
    },
    {
        path: "/servicios/hotel",
        label: "Hotel",
        isActive: true
    }
]

function ListaServiciosHotel(){
    const [items, setItems] = useState([] as ItemListadoServiciosHotel[]);

    useEffect(() => {
        async function poblarItems() {
            const resp = await listarServiciosHotel();
            if(resp){
                setItems(resp);
            }
        }

        poblarItems();
    }, []);

    return (
        <Page description="Visualiza, edita y crea servicios de hotel." title="Reservas de Hotel" breadCrumbs={breadCrumbs}>
            <TableSection items={items} />
        </Page>
    );
}

export default ListaServiciosHotel;